import React from 'react'
import {http} from '../../utils'
import {initDriveApp} from '../../modules/drive'
import {DriveRoot} from '../../modules/drive/app/DriveRoot'
import {FileDrive} from '../../modules/drive/pages/FileDrive'

class DriveList extends React.Component {
  state = {
    ready: false
  }

  componentDidMount() {
    initDriveApp({
      request: http,
      getToken: () => localStorage.getItem('token'),
      theme: () => localStorage.getItem('theme')
    })

    this.setState({ready: true})
  }

  render() {
    if (!this.state.ready) return null

    return <DriveRoot>
      <FileDrive/>
    </DriveRoot>
  }
}

export default DriveList